import { createFileRoute, redirect } from "@tanstack/react-router";

/** Kept so old links still land. Who signs in for a resident now lives on the Family tab. */
export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/portal-access")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/residents/$residentId/family", params });
  },
});
